module.exports = __webpack_public_path__ + "img/pictlogo.eb851269.png";